
//=========================================================
// 路由 核心
//=========================================================

import { createHashRouter } from 'react-router-dom'

import LoginViewController from '../views/account/LoginViewController'
import CodeViewController from '../views/account/CodeViewController'
import ForgotCodeViewController from '../views/account/ForgotCodeViewController'
import ForgotViewController from '../views/account/ForgotViewController'
import RegisterViewController from '../views/account/RegisterViewController'

import Main from '../views/Main'
import HomeViewController from '../views/homepage/HomeViewController'
import MarketViewController from '../views/market/MarketViewController'
import TradeViewController from '../views/trade/TradeViewController'
import CoinOrderViewController from '../views/trade/CoinOrderViewController'
import FuturesOrderViewController from '../views/trade/FuturesOrderViewController'

import AssetsViewController from '../views/assets/AssetsViewController'
import AssetsAccountViewController from '../views/assets/acount/AssetsAccountViewController'
import AssetsTransferViewController from '../views/assets/transfer/AssetsTransferViewController'

import MeViewController from '../views/me/MeViewController'
import MeProfileViewController from '../views/me/profile/ProfileViewController'
import MeEditNameViewController from '../views/me/profile/EditNameViewController'
import MeEditAvatarViewController from '../views/me/profile/EditAvatarViewController'
import MeSecurityViewController from '../views/me/security/SecurityViewController'
import MeLoginPasswordController from '../views/me/security/LoginPasswordController'
import MePaymentPasswordController from '../views/me/security/PaymentPasswordController'
import MeAboutViewController from '../views/me/about/AboutViewController'

import RechargeViewController from '../views/recharge/RechargeViewController'
import WithdrawViewController from '../views/withdraw/WithdrawViewController'

import SearchCoinsController from '../views/search/SearchCoinsController'
import SearchAccountController from '../views/search/SearchAccountController'

import MessageViewController from '../views/message/MessageViewController'
import MessagePreviewController from '../views/message/MessagePreviewController'
import FeedbackController from '../views/feedback/FeedbackController'
import FeedbackPreviewController from '../views/feedback/FeedbackPreviewController'
import FeedbackListController from '../views/feedback/FeedbackListController'
import FeedbackResortController from '../views/feedback/FeedbackResortController'
import FeedbackReplyController from '../views/feedback/FeedbackReplyController'
import ChatController from '../views/chat/ChatController'

import TrendViewController from '../views/trend/TrendViewController'

import AppViewController from '../views/AppViewController'
import LanguagesViewController from '../views/language/LanguagesViewController'

import { NotFound } from '../views/NotFound'

import WrapperRouter from './WrapperRouter'

const router = createHashRouter([
    {
        path : '/',
        element : <Main/>,
        children : [
            {
                path : '/',
                element : <WrapperRouter><HomeViewController/></WrapperRouter>
            },
            {
                path : '/market',
                element : <WrapperRouter><MarketViewController/></WrapperRouter>,
            },
            {
                path : '/trade',
                element : <WrapperRouter><TradeViewController/></WrapperRouter>
            },
            {
                path : '/assets',
                element : <WrapperRouter><AssetsViewController/></WrapperRouter>
            }
        ]
    },
    {
        path: '/trade/coins/order',
        element : <WrapperRouter login={true}><CoinOrderViewController/></WrapperRouter>
    },
    {
        path: '/trade/futures/order',
        element : <WrapperRouter login={true}><FuturesOrderViewController/></WrapperRouter>
    },
    
    {
        path: '/login',
        element : <WrapperRouter><LoginViewController/></WrapperRouter>
    },
    {
        path: '/code',
        element : <WrapperRouter><CodeViewController/></WrapperRouter>
    },
    {
        path: '/forgot_code',
        element : <WrapperRouter><ForgotCodeViewController/></WrapperRouter>
    },
    {
        path: '/forgot',
        element : <WrapperRouter><ForgotViewController/></WrapperRouter>
    },
    {
        path: '/register',
        element : <WrapperRouter><RegisterViewController/></WrapperRouter>
    },
    {
        path: '/me',
        element : <WrapperRouter login={true}><MeViewController/></WrapperRouter>
    },
    {
        path: '/me/profile',
        element : <WrapperRouter login={true}><MeProfileViewController/></WrapperRouter>
    },
    {
        path: '/me/profile/editname',
        element : <WrapperRouter login={true}><MeEditNameViewController/></WrapperRouter>
    },
    {
        path: '/me/profile/editavatar',
        element : <WrapperRouter login={true}><MeEditAvatarViewController/></WrapperRouter>
    },
    {
        path: '/me/security',
        element : <WrapperRouter login={true}><MeSecurityViewController/></WrapperRouter>
    },
    {
        path: '/me/security/password',
        element : <WrapperRouter login={true}><MeLoginPasswordController/></WrapperRouter>
    },
    {
        path: '/me/security/payment',
        element : <WrapperRouter login={true}><MePaymentPasswordController/></WrapperRouter>
    },
    {
        path: '/me/about',
        element : <WrapperRouter><MeAboutViewController/></WrapperRouter>
    },
    {
        path: '/recharge',
        element : <WrapperRouter login={true}><RechargeViewController/></WrapperRouter>
    },
    {
        path: '/withdraw',
        element : <WrapperRouter login={true}><WithdrawViewController/></WrapperRouter>
    },
    {
        path: '/search/coins',
        element : <WrapperRouter><SearchCoinsController/></WrapperRouter>
    },
    {
        path: '/search/account',
        element : <WrapperRouter login={true}><SearchAccountController/></WrapperRouter>
    },
    {
        path: '/message',
        element : <WrapperRouter><MessageViewController/></WrapperRouter>
    },
    {
        path: '/message/preview',
        element : <WrapperRouter><MessagePreviewController/></WrapperRouter>
    },
    
    {
        path: '/feedback',
        element : <WrapperRouter login={true}><FeedbackController/></WrapperRouter>
    },
    {
        path: '/feedback/list',
        element : <WrapperRouter login={true}><FeedbackListController/></WrapperRouter>
    },
    {
        path: '/feedback/reply',
        element : <WrapperRouter login={true}><FeedbackReplyController/></WrapperRouter>
    },
    {
        path: '/feedback/resort',
        element : <WrapperRouter login={true}><FeedbackResortController/></WrapperRouter>
    },
    {
        path : '/chat', 
        element : <WrapperRouter login={true}><ChatController/></WrapperRouter>
    },
    {
        path: '/feedback/preview',
        element : <WrapperRouter login={true}><FeedbackPreviewController/></WrapperRouter>
    },
    {
        path: '/trend',
        element : <WrapperRouter><TrendViewController/></WrapperRouter>
    },
    {
        path: '/assets/account',
        element : <WrapperRouter login={true}><AssetsAccountViewController/></WrapperRouter>
    },
    {
        path: '/assets/transfer',
        element : <WrapperRouter login={true}><AssetsTransferViewController/></WrapperRouter>
    },
    {
        path: '/app',
        element : <WrapperRouter><AppViewController/></WrapperRouter>
    },
    {
        path: '/languages',
        element : <WrapperRouter><LanguagesViewController/></WrapperRouter>
    },
    {
        path: '/*',
        element : <WrapperRouter><NotFound/></WrapperRouter>
    }
])

export default router